import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import SetMovementEnabledNodePreview from "../../features/sequence/node_previews/SetMovementEnabledNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  getBooleanSearchLabels,
} from "./SearchableInteractionValues";

export interface ISetMovementEnabled extends Interaction {
  movementEnabled: boolean;
}

export const setMovementEnabledInteraction = (): InteractionFactoryEntity => {
  const view = <></>;

  const create = (
    getKeys: (amount: number) => string[]
  ): ISetMovementEnabled => {
    return {
      id: GetNewGuid(),
      name: "Set Movement Enabled",
      type: InteractionType.SetMovementEnabled,
      movementEnabled: true,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): ISetMovementEnabled => {
    return interaction as ISetMovementEnabled;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): ISetMovementEnabled => {
    return {
      ...(interaction as ISetMovementEnabled),
      id: GetNewGuid(),
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as ISetMovementEnabled;
    return getMatchingResults(
      compactSearchableStrings(
        interaction.name,
        getBooleanSearchLabels(
          converted.movementEnabled,
          "Movement Enabled",
          "Movement Disabled",
        ),
      ),
      takeName,
      interaction,
      "Set Movement Enabled"
    );
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    return [];
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <SetMovementEnabledNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: "Set Movement Enabled",
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
